module.exports = __webpack_public_path__ + "static/media/sunset.26385ae6.jpg";